import { inject, Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Observable } from "rxjs";
import { ChangeAddressModel } from "@modules/shared/modals/change-personal-info/domain/entities/change-user-info.model";

@Injectable({
	providedIn: "root"
})
export class ChangeUserInfoRemote {
	private readonly apiCallService = inject(ApicallService);

	public requestSmsCodeNewEmail$(): Observable<void> {
		return this.apiCallService.post(`user/email`, new ApicallOption());
	}

	public postNewEmail$(code: string, email: string, is2faActive: boolean): Observable<void> {
		const jsonBody = is2faActive ? { email, auth_code: code } : { email, sms_pin_code: code };
		const option = new ApicallOption(null, jsonBody);
		return this.apiCallService.post(`user/email`, option);
	}

	public putNewEmailConfirmation$(code: string): Observable<void> {
		return this.apiCallService.put(`user/email?email_code=${code}`);
	}

	public requestSmsCodeNewAddress$(): Observable<void> {
		return this.apiCallService.post(`user/address`, new ApicallOption());
	}

	public postNewAddress$(code: string, newAddress: ChangeAddressModel, is2faActive: boolean): Observable<void> {
		const jsonBody: ChangeAddressModel = is2faActive
			? { ...newAddress, auth_code: code }
			: { ...newAddress, sms_pin_code: code };
		const option = new ApicallOption(null, jsonBody);
		return this.apiCallService.post(`user/address`, option);
	}
}
